<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-27 23:57:16
 * @LastEditTime: 2019-09-28 18:16:06
 * @LastEditors: Please set LastEditors
 -->
<template>
  <el-dialog
    v-if="personData.state"
    class="selfModal"
    title="选择用户"
    :close-on-click-modal="false"
    :visible="personData.state"
    width="1100px"
    :modal="false"
    @close="closeModal()"
  >
    <div style="position: relative; height: 100%; display: none">
      <treeMenu
        ref="treeMenu"
        initId="0"
        :showBox="false"
        :showArrow="false"
        loadStyle="staticLoad"
        style="width: 30%; dispaly: inline-block"
        @nodeClick="getNodeId"
      ></treeMenu>
      <div class="selectUser-right">
        <div class="M_search" style="padding: 0">
          <el-input
            placeholder="请输入姓名"
            v-model="name"
            style="width: auto"
          />
          <el-button
            icon="el-icon-search"
            @click="searchChange"
            type="primary"
            style="margin-left: 10px"
            >搜 索
          </el-button>
          <el-button icon="el-icon-delete" @click="emptySearch"
            >清 空</el-button
          >
        </div>
        <div class="tableHeight2" style="padding-left: 0">
          <el-table
            v-loading="tableLoading"
            ref="chargeManTable"
            :data="usertableData"
            tooltip-effect="dark"
            stripe
            border
            height="100%"
            style="min-width: 100%; min-height: 100%"
            @select="rowSelection"
            @selection-change="selectionChange"
            @select-all="allSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="65"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="姓名"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column label="类型">
              <template slot-scope="scope">
                {{ transfer(scope.row.type) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page-container" style="text-align: center">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-size="pageSize"
            layout="total, prev, pager, next"
            :total="pageTotal"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="submitForm" :disabled="subDisabled">确 定</el-button>
            <el-button @click="closeModal">关 闭</el-button>
        </span> -->
    <div class="container_content">
      <selectUser
        ref="selectUser"
        :paramsData="paramsData"
        @selectAll="selectAllUser"
        @selectResult="getSelectResult"
        @closeSelectUser="closeModal"
      ></selectUser>
    </div>
    <!-- <span v-if="personData.type !=='radio'" slot="footer" class="dialog-footer">
         <el-button type="primary" @click="sureClick_s(false)"
         >确 认
        </el-button
        >
        <el-button @click="handleDialogClose_s">关 闭</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
import treeMenu from "@/components/treeMenu/index.vue";
import { getUserPage } from "@/api/admin/user"; //
import { saveDepartCharge, getDepartCharge } from "@/api/admin/dept"; //
import { globalData } from "@/util/globaldata";
import selectUser from "@/components/dialog/jobEvaluation/assessmentManage/selectUser.vue";

export default {
  props: {
    personData: {
      type: Object,
      required: true,
    },
  },
  components: { treeMenu, selectUser },
  data() {
    return {
      subDisabled: false,
      tableLoading: false,
      usertableData: [],
      showData: false,
      pageIndex: 1,
      pageSize: 10,
      pageTotal: 0,
      deptId: null,
      name: null,
      chooseMans: [],
      chooseManArr: [],
      chooseAll: false,
      paramsData: {
        fn: true,
        type: "",
        key: Date.parse(new Date()),
        defaultSelected: [],
        selectedUserListArr: [],
      },
    };
  },
  computed: {},
  watch: {
    "personData.state"(newval) {
      if (newval) {
        this.paramsData.key = Date.parse(new Date());
        this.paramsData.type = this.personData.type || "";
        this.paramsData.defaultSelected =
          this.personData.userData.length > 0 ? this.personData.userData : [];
        this.paramsData.selectedUserListArr =
          this.personData.data.length > 0 ? this.personData.data : [];
        this.$nextTick(() => {
          this.$refs.selectUser.initData(this.paramsData);
        });
      }
    },
  },
  methods: {
    // sureClick_s(){
    //     this.$refs.selectUser.sureClick(false)
    // },
    // handleDialogClose_s(){
    //     this.$refs.selectUser.handleDialogClose(false)
    // },
    selectAllUser(data) {},
    getSelectResult(data) {
      const idArr = data.data.map(item => {
        return item.userId;
      });
      const userNameArr = data.data.map(item => {
        return item.userName;
      });
      this.chooseManArr = data.data;
      this.chooseMans = idArr;
      // let charges= this.chooseMans != [] ? this.chooseMans.toString() : null;
      this.$emit("closePerson", {
        state: false,
        data: this.chooseMans,
        mans: this.chooseManArr,
      });
      this.deptId = "";
      this.name = "";
      this.pageIndex = 1;
      // this.paramsData.selectedUserIdArr=[];
      // this.paramsData.selectedUserListArr=[];
      // this.$refs.selectUser.initData(this.paramsData);
    },
    /**
     * @description: 确认保存
     * @param:{}
     * @return:
     */
    submitForm() {
      this.personData.data = this.chooseManArr;
      this.personData.userData = this.chooseMans;
      this.subDisabled = true;
      this.$emit("closePerson", {
        state: false,
        data: this.chooseMans,
        mans: this.chooseManArr,
      });
      this.deptId = "";
      this.name = "";
      this.pageIndex = 1;
      this.subDisabled = false;
    },
    /**
     * @description: 类型
     * @param:{}
     * @return:
     */
    transfer(value) {
      return globalData.transfer(globalData.System.userTypes, value);
    },
    /**
     * @description: 全选
     * @param:{}
     * @return:
     */
    allSelectionChange(selection) {
      if (selection.length > 0) {
        this.chooseAll = true;
      } else {
        this.chooseAll = false;
        for (let i = 0; i < this.usertableData.length; i++) {
          for (let j = 0; j < this.chooseMans.length; j++) {
            if (this.usertableData[i].userId == this.chooseMans[j]) {
              this.chooseMans.splice(j, 1);
              this.chooseManArr.splice(j, 1);
            }
          }
        }
      }
    },
    /**
     * @description: 去重
     * @param:{}
     * @return:
     */
    unique(arr) {
      const res = new Map();
      return arr.filter(a => !res.has(a) && res.set(a, 1));
    },
    /**
     * @description: 表格数据选择
     * @param:{}
     * @return:
     */
    selectionChange(selections, row) {
      for (let j = 0; j < selections.length; j++) {
        this.chooseMans.push(selections[j].userId);
        this.chooseManArr.push({
          userId: selections[j].userId,
          userName: selections[j].name,
        });
      }
      this.chooseMans = this.unique(this.chooseMans);

      // this.chooseManArr = this.unique(this.chooseManArr);
      let obj = {}; //数组对象去重
      this.chooseManArr = this.chooseManArr.reduce(function (item, next) {
        obj[next.userId] ? "" : (obj[next.userId] = true && item.push(next));
        return item;
      }, []);
    },
    /**
     * @description: 表格数据单选
     * @param:{}
     * @return:
     */
    rowSelection(selections, row) {
      let found = false;
      for (let i = 0; i < this.chooseMans.length; i++) {
        if (row.userId == this.chooseMans[i]) {
          this.chooseMans.splice(i, 1);
          this.chooseManArr.splice(i, 1);
          found = true;
          break;
        }
      }
      // for (let i = 0; i <selections.length; i++) {
      //     this.chooseMans.push(selections[i].userId);
      //     this.chooseManArr.push({userId:selections[i].userId,userName:selections[i].name});
      //     // this.chooseMans = this.unique(this.chooseMans);
      //     // this.chooseManArr = this.unique(this.chooseManArr);
      // }
      //
      // this.chooseMans = this.unique(this.chooseMans);
      // // this.chooseManArr = this.unique(this.chooseManArr);
      // let obj = {};//数组对象去重
      // this.chooseManArr = this.chooseManArr.reduce(function (item, next) {
      //     obj[next.userId] ? '' : obj[next.userId] = true && item.push(next);
      //     return item;
      // }, []);
    },
    handleCurrentChange(page) {
      // this.searchusers(page);
      this.pageIndex = page;
      this.RefreshData();
    },
    /**
     * @description: 搜，清空
     * @param:{}
     * @return:
     */
    searchChange() {
      this.RefreshData();
    },
    emptySearch() {
      this.name = "";
      this.RefreshData();
    },
    /**
     * @description: 加载数据列表
     * @param:{}
     * @return:
     */
    RefreshData() {
      console.log(this.chooseMans, "this.chooseMans");
      this.tableLoading = true;
      if (this.personData) {
        let queryObj = {
          current: this.pageIndex,
          size: this.pageSize,
          deptId: this.deptId,
          name: this.name,
        };
        getUserPage(queryObj).then(res => {
          if (res.data.code == 0) {
            this.usertableData = res.data.data.records;
            this.pageTotal = res.data.data.total;
            this.tableLoading = false;
            let ids = this.chooseMans;
            let that = this;
            that.$nextTick(() => {
              that.$refs.chargeManTable.clearSelection();
              if (ids.length > 0) {
                ids.forEach(e => {
                  that.usertableData.forEach((me, index) => {
                    if (me.userId == e) {
                      that.$refs.chargeManTable.toggleRowSelection(
                        that.usertableData[index]
                      );
                    }
                  });
                });
              }
            });
          } else {
            this.tableLoading = false;
            this.$alert(res.data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning",
            });
          }
        });
      }
    },
    /**
     * @description: 默认加载数据
     * @param:{}
     * @return:
     */
    loadData() {
      this.chooseManArr = this.personData.data;
      this.chooseMans = this.personData.userData;
      this.chooseMans = this.unique(this.chooseMans);
      // this.chooseManArr = this.unique(this.chooseManArr);
      let obj = {}; //数组对象去重
      this.chooseManArr = this.chooseManArr.reduce(function (item, next) {
        obj[next.userId] ? "" : (obj[next.userId] = true && item.push(next));
        return item;
      }, []);
      console.log(this.chooseMans, "this.chooseMans------------");
      this.RefreshData();
      const idArr = this.personData.data.map(e => {
        return e.userId;
      });
      this.paramsData.defaultSelected = idArr;
      this.paramsData.selectedUserListArr = this.personData.data;
      // if(this.personData.state){
      //     this.$nextTick(() => {
      //         this.$refs.selectUser.initData(this.paramsData)
      //      })
      // }
    },
    /**
     * @description: 点击tree
     * @param:{}
     * @return:
     */
    getNodeId(data) {
      this.deptId = data.id;
      this.RefreshData();
    },
    closeModal() {
      this.chooseManArr = this.personData.data;
      this.chooseMans = this.personData.userData;
      // let charges= this.chooseMans != [] ? this.chooseMans.toString() : null;
      this.$emit("closePerson", {
        state: false,
        data: this.chooseMans,
        mans: null,
      });
      this.deptId = "";
      this.name = "";
      this.pageIndex = 1;
      this.paramsData.selectedUserIdArr = [];
      this.paramsData.selectedUserListArr = [];
      this.$refs.selectUser.initData(this.paramsData);
    },
  },
};
</script>
<style lang="less">
.chargePerson_dialog {
  .el-dialog {
    // height: calc(100vh - 110px) !important;
    margin: 0 auto 0;
    margin-top: 10vh !important;
  }
  .el-dialog .el-dialog__body {
    height: calc(100% - 60px) !important;
    overflow: auto;
    padding: 10px 0 20px;
  }
}
</style>

<style lang="less" scoped>
.container_content {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  background: #fff;
}
.selectUser-right {
  width: 65%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
}
</style>
